import React from 'react';
import { useAuth } from '../../context/AuthContext';
import './UserProfile.css';

const UserProfile = () => {
  const { user } = useAuth();

  if (!user) {
    return null;
  }

  return (
    <div className="user-profile">
      <img src={user.picture.split('=')[0]} alt="User" className="user-picture" />
      <div className="user-details">
        <span className="user-name">{`${user.given_name} ${user.family_name}`}</span>
        <span className="user-email">{user.email}</span>
      </div>
    </div>
  );
};

export default UserProfile;
